import { PreviewThumb } from '@/components/PreviewThumb';
import { getDataSource } from '../../data/dataSourceFactory';

interface Props {
  studyInstanceUID: string;
}

/** Worklist thumbnail cell. Uses the backend WADO-RS thumbnail resource directly
 *  as the <img> src — natively lazy-loaded and browser-cached — with the shared
 *  hover-enlarge. No per-row metadata round-trip. */
export function StudyThumbnail({ studyInstanceUID }: Props) {
  const url = getDataSource().studyThumbnailUrl(studyInstanceUID);
  return <PreviewThumb url={url} className="h-12 w-12" />;
}
